class SubscriptionPlanWidget {
  constructor(root) {
    this.root = root;
    this.optionName = root.dataset.optionName;
    this.radios = Array.from(root.querySelectorAll(`input[name="${this.optionName}"]`));
    this.subscriptionRadios = this.radios.filter((radio) => radio.value === 'subscription');
    this.onetimeRadio = this.radios.find((radio) => radio.value === 'onetime');

    if (!this.radios.length) return;

    this.sortSubscriptionCards();
    this.selectFirstVisibleRadio();
    this.bindEvents();
    this.syncSelection();
    this.removeRechargeWrapperAfterInit();
  }

  bindEvents() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.syncSelection());
    });
  }

  getForms() {
    const forms = [];
    const productInfo = this.root.closest('product-info');

    if (productInfo) {
      productInfo.querySelectorAll("form[action='/cart/add']").forEach((form) => forms.push(form));
    }

    const stickyForm = document.querySelector('#sticky_form_add_to_cart');
    if (stickyForm && !forms.includes(stickyForm)) {
      forms.push(stickyForm);
    }

    return forms;
  }

  ensureInput(form, name) {
    let input = form.querySelector(`input[name='${name}']`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  updateActiveState(selectedRadio) {
    this.root.querySelectorAll('.rc-radio').forEach((label) => {
      label.classList.remove('rc-radio--active');
    });

    const selectedLabel = selectedRadio?.closest('.rc-radio');
    if (selectedLabel) selectedLabel.classList.add('rc-radio--active');
  }

  updateAtcPrice(selectedRadio) {
    const normalPrices = document.querySelectorAll('[js-normal-price]');
    const comparePrices = document.querySelectorAll('[js-compare-price]');

    if (selectedRadio?.value === 'subscription') {
      const label = selectedRadio.closest('.rc-radio');
      const normal =
        selectedRadio.dataset.atcPlanPrice
        || label?.querySelector('.subs-original-price')?.textContent?.trim()
        || '';
      const compare =
        selectedRadio.dataset.atcComparePrice
        || label?.querySelector('.subs-compare-price')?.textContent?.trim()
        || '';

      normalPrices.forEach((el) => {
        el.textContent = normal;
      });
      comparePrices.forEach((el) => {
        el.textContent = compare;
      });
      return;
    }

    if (selectedRadio?.value === 'onetime') {
      const label = selectedRadio.closest('.rc-radio');
      const normal = label?.querySelector('.compare-price')?.textContent?.trim() || '';
      const compare = label?.querySelector('.regular-price')?.textContent?.trim() || '';

      normalPrices.forEach((el) => {
        el.textContent = normal;
      });
      comparePrices.forEach((el) => {
        el.textContent = compare;
      });
    }
  }

  sortSubscriptionCards() {
    const widget = this.root.querySelector('.rc-widget');
    if (!widget) return;

    const subscriptionCards = Array.from(widget.querySelectorAll('.subscription-radio'));
    if (subscriptionCards.length < 2) return;

    const onetimeCard = widget.querySelector('.onetime-radio');
    subscriptionCards.sort((a, b) => {
      const aDays = Number(a.querySelector("input[value='subscription']")?.dataset.planDays || 0);
      const bDays = Number(b.querySelector("input[value='subscription']")?.dataset.planDays || 0);
      return bDays - aDays;
    });

    subscriptionCards.forEach((card) => {
      if (onetimeCard) widget.insertBefore(card, onetimeCard);
      else widget.appendChild(card);
    });
  }

  selectFirstVisibleRadio() {
    const orderedSubscriptionRadios = Array.from(
      this.root.querySelectorAll(`input[name="${this.optionName}"][value="subscription"]`)
    );
    if (!orderedSubscriptionRadios.length) return;

    this.radios.forEach((radio) => {
      radio.checked = false;
    });
    orderedSubscriptionRadios[0].checked = true;
  }

  syncFormInputs(selectedRadio) {
    const forms = this.getForms();
    if (!forms.length) return;

    const productId = selectedRadio?.dataset.subscriptionProductId || '';
    const sellingPlanId = selectedRadio?.dataset.sellingPlanId || '';
    const isSubscription = selectedRadio?.value === 'subscription';

    forms.forEach((form) => {
      const variantInput = this.ensureInput(form, 'id');
      const sellingPlanInput = this.ensureInput(form, 'selling_plan');

      if (productId) {
        variantInput.value = productId;
      }

      sellingPlanInput.value = isSubscription ? sellingPlanId : '';
    });

    const stickySellingPlanInput = document.querySelector('[js-sticky-selling-plan]');
    if (stickySellingPlanInput) {
      stickySellingPlanInput.value = isSubscription ? sellingPlanId : '';
    }
  }

  syncSelection() {
    const selectedRadio = this.radios.find((radio) => radio.checked) || this.subscriptionRadios[0] || this.onetimeRadio;
    if (!selectedRadio) return;

    selectedRadio.checked = true;
    this.updateActiveState(selectedRadio);
    this.syncFormInputs(selectedRadio);
    this.updateAtcPrice(selectedRadio);
    if (typeof window.updateSubscription === 'function') {
      window.updateSubscription(selectedRadio.value);
    }
  }

  removeRechargeWrapperAfterInit() {
    const removeWrapper = () => {
      const wrappers = document.querySelectorAll('[data-widget-container-wrapper]');
      if (!wrappers.length) return false;

      wrappers.forEach((element) => {
        element.remove();
      });
      return true;
    };

    if (removeWrapper()) return;

    const observer = new MutationObserver(() => {
      if (removeWrapper()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-subscription-plan-widget]').forEach((root) => {
    new SubscriptionPlanWidget(root);
  });
});
